import { DataPoint } from '../../../types/data-point.js';

export const populateSelectedDatapointsMap = (
  datapointsMap: Map<string, DataPoint[]>,
  key: string,
  dataPoint: DataPoint | DataPoint[],
) => {
  if (Array.isArray(dataPoint)) {
    dataPoint.forEach((dp, idx) => {
      const uniqueKey = `${key}_${idx}`;
      const existing = datapointsMap.get(uniqueKey) ?? [];
      datapointsMap.set(uniqueKey, [...existing, dp]);
    });
  } else {
    const existing = datapointsMap.get(key) ?? [];
    datapointsMap.set(key, [...existing, dataPoint]);
  }
};
